import EmitterManager from './EmitterManager';
import {
  RESIZE,
  RESIZE_UPDATE,
  BREAKPOINT,
  LOAD,
  DOM_CONTENT_LOADED,
  VIEW_READY,
} from '../core/Events';

const defaults = {
  autoEnable: true,
};

class ResizeManager {
  constructor(options) {
    this.options = Object.assign({}, defaults, options);
    this.bind();

    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.mqls = {
      isTabletPortrait: window.matchMedia('(max-width: 1023px)'),
      isMobile: window.matchMedia('(max-width: 767px)'),
    };

    if (this.options.autoEnable) {
      this.enable();
      this.handleResize();
    }
  }

  get medias() {
    return {
      isMobile: this.mqls.isMobile.matches,
    };
  }

  bind() {
    this.handleResize = this.handleResize.bind(this);
    this.handleMediaQuery = this.handleMediaQuery.bind(this);
    this.emitResizeEvent = this.emitResizeEvent.bind(this);
    this.handleViewReady = this.handleViewReady.bind(this);
  }

  enable() {
    this.events(true);
  }

  disable() {
    this.events(false);
  }

  events(listen = false) {
    let method = null;

    method = listen === false ? 'removeEventListener' : 'addEventListener';
    window[method](RESIZE, this.handleResize);
    window[method](DOM_CONTENT_LOADED, this.handleResize);
    window[method](LOAD, this.handleResize);

    method = listen === false ? 'removeListener' : 'addListener';
    EmitterManager[method](RESIZE_UPDATE, this.handleResize);
    EmitterManager[method](VIEW_READY, this.handleViewReady);

    Object.keys(this.mqls).forEach((key) => this.mqls[key][method](this.handleMediaQuery));
  }

  handleMediaQuery() {
    const result = {};

    Object.keys(this.mqls).forEach((key) => {
      result[key] = this.mqls[key].matches;
    });

    EmitterManager.emit(BREAKPOINT, result);
  }

  handleViewReady() {
    this.handleMediaQuery();
  }

  handleResize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.scrollHeight = document.body.scrollHeight;

    document.documentElement.style.setProperty('--vh', `${this.height * 0.01}px`);

    if (this.resizeTicking !== true) {
      requestAnimationFrame(this.emitResizeEvent);
    }

    this.resizeTicking = true;
  }

  emitResizeEvent() {
    EmitterManager.emit(RESIZE, this.width, this.height);

    this.resizeTicking = false;
  }
}

export default new ResizeManager();
